<template>
    <v-select v-model="inputValue"
              :items="items"
              :item-text="itemText"
              :item-value="itemValue"
              :clearable="true"
              :disabled="disabled"
              :placeholder="placeholder"
    ></v-select>
</template>

<script>
export default {
  name: 'Lookup',
  props: {
    value: String,
    title: String,
    label: String,
    document: String,
    placeholder: String,
    query: String,
    itemText: String,
    itemValue: String
  },
  data () {
    return {
      inputValue: this.value,
      disabled: true,
      loading: false,
      items: [],
      search: null,
      paramValue: null
    }
  },
  mounted () {
    this.$log.debug(`mounted`)
    this.remoteLookup()
  },
  methods: {
    // execute () {
    //   this.$log.debug(`Lookup execute: ${this.inputValue}`)
    //   this.$emit('input', this.inputValue)
    // },
    setValue (value) {
      this.paramValue = value
    },
    clear () {
      this.inputValue = null
      this.items = []
      this.disabled = true
    },
    remoteLookup (localQuery) {
      this.loading = true
      this.$log.debug(`Lookup Document: ${this.document}`)
      this.$log.debug(`Lookup Query: ${localQuery}`)
      this.axios.get(`lookup`, {
        params: {
          d: this.document,
          q: (localQuery) || this.query,
          s: 1000
        } })
        .then(response => {
          this.$log.debug('Lookup OK')
          this.items = response.data.data
          if (this.items) {
            this.disabled = false
            if (this.paramValue) {
              this.inputValue = { make: this.paramValue }
            }
          }
        })
        .catch(e => {
          this.$log.error(e)
        }).finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    inputValue (val) {
      this.$log.debug(val)
      if (val && (typeof val === 'object')) {
        this.$emit('input', val[this.itemText])
      } else {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style scoped>

</style>
